import PropTypes from 'prop-types'
import { useState } from 'react'
import { Asset } from '@opallabs/kuiper'
import { MobileStreamHeader, MobileStreamFooter } from '../index'
import { styles } from './styles'

export const MobileStream = ({
  accountImage,
  accountUsername,
  asset,
  collabAccount,
  content = '',
  contentCharacterLimit,
  contentPlaceholderText,
  description = '',
  effect = '',
  instagramCollab,
  isPresenting,
  location,
  maintainAspectRatio = false,
  musicTitle = '',
  onContentChange,
  onExpandAsset,
  onMusicChange,
  onRemoveAsset,
  postType,
  readOnly,
  truncate = false,
  updateCaption,
  updateCoverAsset,
}) => {
  const [isHovered, setIsHovered] = useState(false)

  return (
    <div css={styles.flexColumn}>
      <MobileStreamHeader
        accountUsername={accountUsername}
        accountImage={accountImage}
        collabAccount={collabAccount}
        instagramCollab={instagramCollab}
        location={location}
        musicTitle={musicTitle}
        onMusicChange={onMusicChange}
        postType={postType}
        readOnly={readOnly}
      />
      <div
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <Asset
          imageFit="cover"
          assetReference={asset}
          placeholder={true}
          isHovered={isHovered}
          removeable={!isPresenting}
          disableCoverAsset={false}
          hasAssetOptions={true}
          onEmbiggen={() => onExpandAsset(asset.id)}
          onRemove={() => onRemoveAsset(asset.id)}
          updateCaption={updateCaption}
          updateCoverAsset={(val) => updateCoverAsset(val, asset.id)}
          overrideStyles={{
            asset: styles.makeAssetStyles(maintainAspectRatio, Boolean(asset)),
            assetBase: styles.makeAssetBaseStyles(
              maintainAspectRatio,
              Boolean(asset)
            ),
          }}
          hasAssetOverlay={Boolean(asset) && (!readOnly || isPresenting)}
        />
      </div>
      <MobileStreamFooter
        accountUsername={accountUsername}
        content={content}
        contentCharacterLimit={contentCharacterLimit}
        contentPlaceholderText={contentPlaceholderText}
        description={description}
        effect={effect}
        isPresenting={isPresenting}
        onContentChange={onContentChange}
        postType={postType}
        readOnly={readOnly}
        truncate={truncate}
      />
    </div>
  )
}

MobileStream.propTypes = {
  accountImage: PropTypes.object,
  accountUsername: PropTypes.string,
  asset: PropTypes.object,
  collabAccount: PropTypes.string,
  content: PropTypes.string,
  contentCharacterLimit: PropTypes.number,
  contentPlaceholderText: PropTypes.string,
  description: PropTypes.string,
  effect: PropTypes.string,
  instagramCollab: PropTypes.bool,
  isPresenting: PropTypes.bool,
  location: PropTypes.string,
  maintainAspectRatio: PropTypes.bool,
  musicTitle: PropTypes.string,
  onContentChange: PropTypes.func,
  onExpandAsset: PropTypes.func,
  onMusicChange: PropTypes.func,
  onRemoveAsset: PropTypes.func,
  postType: PropTypes.string,
  readOnly: PropTypes.bool,
  truncate: PropTypes.bool,
  updateCaption: PropTypes.func,
  updateCoverAsset: PropTypes.func,
}
